// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__52z_1","nav__wrap":"Nav_nav__wrap__0dCMD"};